import styled, { keyframes } from "styled-components";
import materialUI from "../../material-UI";

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
`;

export const Modal = styled(materialUI.Dialog)`
  .MuiDialog-paper {
    overflow: hidden;
    border-radius: 12px;
    width: min(860px, 96vw);
    max-width: min(860px, 96vw);
    height: min(620px, 88vh);
    max-height: min(620px, 88vh);
    margin: 12px;
  }

  &.shake-true {
    .MuiDialog-paper {
      animation: shake 0.35s;
      animation-iteration-count: 1;
    }

    @keyframes shake {
      0% {
        transform: translate(1px, 0px);
      }
      25% {
        transform: translate(-2px, 0px);
      }
      50% {
        transform: translate(2px, 0px);
      }
      75% {
        transform: translate(-1px, 0px);
      }
    }
  }
`;

export const Window = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f0f2f5;
  min-width: 0;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 14px;
  background: #f0f2f5;
  border-bottom: 1px solid #d9dee2;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

export const AvatarImage = styled.img`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #d9dee2;
  flex-shrink: 0;
`;

export const AvatarFallback = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #dfe5eb;
  color: #51606b;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const HeaderMeta = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const LeadName = styled.div`
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #111b21;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LeadStatus = styled.div`
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #25d366;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #54656f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #e9edef;
  }
`;

export const ChatBody = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
  background-color: #ebe5dd;
  background-image: radial-gradient(
      circle at 25px 25px,
      rgba(255, 255, 255, 0.15) 2px,
      transparent 2px
    ),
    radial-gradient(
      circle at 75px 75px,
      rgba(255, 255, 255, 0.15) 2px,
      transparent 2px
    );
  background-size: 100px 100px;
`;

export const MessagesScroller = styled.div`
  flex: 1;
  overflow-y: auto;
  min-width: 0;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

export const CenterHint = styled.div`
  margin: auto auto;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 8px;
  padding: 14px 24px;
  color: #667781;
  font-size: 13px;
  font-family: "Inter", sans-serif;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const EditingMessageBar = styled.div`
  background: #e6f7eb;
  border-top: 1px solid #c7efd4;
  border-bottom: 1px solid #c7efd4;
  padding: 7px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const EditingMessageText = styled.span`
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #15803d;
  font-weight: 600;
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EditingMessageCancel = styled.button`
  border: none;
  background: transparent;
  color: #475569;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: #0f172a;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Composer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  border-top: 1px solid #d9dee2;
  background: #f0f2f5;
  min-width: 0;
  box-sizing: border-box;
`;

export const AttachButton = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #54656f;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #e4e7ea;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const EmojiPickerWrapper = styled.div`
  position: relative;
`;

export const IconCircleButton = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #54656f;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #e4e7ea;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const EmojiPopover = styled.div`
  position: absolute;
  bottom: calc(100% + 10px);
  left: 0;
  width: min(330px, 82vw);
  z-index: 40;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.22);
  border-radius: 10px;
  overflow: hidden;
`;

export const MessageInput = styled.textarea`
  flex: 1;
  min-width: 0;
  min-height: 38px;
  border: 1px solid #d9dee2;
  border-radius: 8px;
  background: #ffffff;
  padding: 8px 14px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.35;
  outline: none;
  color: #111b21;
  resize: none;
  overflow-y: hidden;

  &:focus {
    border-color: #25d366;
    box-shadow: 0 0 0 2px rgba(37, 211, 102, 0.14);
  }

  &::placeholder {
    color: #8696a0;
  }

  &:disabled {
    background: #f6f8fa;
    cursor: not-allowed;
  }
`;

export const RecordingBar = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff5f5;
  border-radius: 8px;
  padding: 10px 12px;
  border: 1px solid #ffe1e1;
`;

export const RecordDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ef4444;
  animation: ${pulse} 1s infinite;
  flex-shrink: 0;
`;

export const RecordTime = styled.span`
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #ef4444;
  font-weight: 600;
`;

export const RecordLabel = styled.span`
  margin-left: auto;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #b42318;
`;

export const SendButton = styled.button<{ variant?: "danger" }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 50%;
  background-color: ${(props) =>
    props.variant === "danger" ? "#ef4444" : "#00a884"};
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background-color: ${(props) =>
      props.variant === "danger" ? "#dc2626" : "#07997a"};
  }

  &:disabled {
    background-color: #c4cbd3;
    cursor: not-allowed;
    opacity: 1;
  }
`;

export const AttachmentPreviewBar = styled.div`
  background: #f0f2f5;
  border-top: 1px solid #d9dee2;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 640px) {
    flex-wrap: wrap;
  }
`;

export const AttachmentPreviewMedia = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 10px;
  background: #e2e8f0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  audio {
    width: 100%;
    height: 38px;
    padding: 0 4px;
  }
`;

export const AttachmentDocIcon = styled.div`
  width: 100%;
  height: 100%;
  color: #475569;
  display: grid;
  place-items: center;
  background: #e5e7eb;
`;

export const AttachmentPreviewInfo = styled.div`
  min-width: 0;
  flex: 1;
`;

export const AttachmentPreviewName = styled.div`
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #111b21;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AttachmentPreviewMeta = styled.div`
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #667781;
  margin-top: 2px;
`;

export const AttachmentPreviewActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const AttachmentActionButton = styled.button<{ primary?: boolean }>`
  border: 1px solid ${(props) => (props.primary ? "#25d366" : "#d5dde8")};
  background: ${(props) => (props.primary ? "#25d366" : "#ffffff")};
  color: ${(props) => (props.primary ? "#ffffff" : "#475569")};
  border-radius: 9px;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
